export default {
  created() {
    if (!/^El/.test((this as any).$options.name) && !['transition', 'TabBar', 'TabNav'].includes((this as any).$options.name)) {
      console.group((this as any).$options.name);
      console.log('created', (this as any).$options.name);
    }
  },
  mounted() {
    if (!/^El/.test((this as any).$options.name) && !['transition', 'TabBar', 'TabNav'].includes((this as any).$options.name)) {
      console.groupEnd();
      console.log('mounted', (this as any).$options.name);
    }
  }
}